import { Component, EventEmitter, inject, Input, OnInit, Output } from '@angular/core';
import { Apartment } from '@modules/universal-billing/apartments/apartments.interface';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { MetersService } from '@modules/settings/meters/meters.service';
import { PTableCellValueComponent } from "@primeng/table/components/p-table-cell-value/p-table-cell-value.component";
import { Table } from "@primeng/table";
import { BasicTableComponent } from '@common/references/basic-table.component';
import { Meter } from '@modules/settings/meters/meters.interfaces';
import { Observable } from 'rxjs';
import { PageResult } from '@shared/components/classes/page-result';
import {
  CounterDetails
} from '@modules/universal-billing/meters/counter-details/counter-details';
import { UnitTypeNamePipe } from '@common/pipe/unit-type-name.pipe';
import { TooltipModule } from '@primeng/tooltip';
import { ModalClose } from '@shared/services/modal/modal.enum';
import { SharedModule } from '@primeng/api';
import { NgbTooltip } from "@ng-bootstrap/ng-bootstrap";
import {
  MeterReadingsComponent
} from "@modules/settings/meters/meter-readings/meter-readings.component";
import { ModalServiceOption } from '@shared/services/modal/modal.interface';
import { removeEmptyProperties } from '@shared/utils/object.utils';
import { Property } from '@modules/settings/properties/properties.interface';

@Component({
  selector: 'app-meters',
  standalone: true,
  imports: [
    TranslatePipe,
    PTableCellValueComponent,
    Table,
    TooltipModule,
    SharedModule,
    NgbTooltip
  ],
  templateUrl: './meters.component.html',
  styleUrl: './meters.component.scss'
})
export class MetersComponent extends BasicTableComponent<Meter> implements OnInit {
  @Input() apartment: Apartment;
  @Input() property: Property;
  @Output() successEvent = new EventEmitter();
  service = inject(MetersService);
  dateFields = ['installationDate'];
  unitPipe = new UnitTypeNamePipe();
  protected translate = inject(TranslateService);

  getAll(params: any): Observable<PageResult<Meter>> {
    if (this.apartment) {
      params.apartmentId = this.apartment?.id;
    }else if (this.property) {
      params.buildingId = this.property?.id;
    }
    return super.getAll(removeEmptyProperties(params));
  }

  openDetails(meter) {
    const translated = this.translate.instant('PROPERTY.COUNTER_DETAILS')
    this.modalService.open({
      component: CounterDetails,
      title: `${translated}`,
      componentOptions: {
        meter: meter,
      },
      modalOptions: {}
    });
  }

  getCreateModalOptions() {
    return {
      ...super.getCreateModalOptions(),
      title: this.translate.instant('METER.ADD_COUNTER'),
      componentOptions: {
        apartment: this.apartment,
        building: this.property
      },
    }
  }
  onSuccessAdd() {
    super.onSuccessAdd();
    this.successEvent.emit();
  }
  onSuccessDelete() {
    super.onSuccessDelete();
    this.successEvent.emit();
  }

  getEditModalOptions(data: Meter): ModalServiceOption {
    return {
      ...super.getEditModalOptions(data),
      title: this.translate.instant('PROPERTY.COUNTER.COUNTER_EDIT'),
      componentOptions: {
        apartment: this.apartment,
        building: this.property,
        selectedRow: data,
        isEdit: true
      }
    }
  }

  openReadings(data) {
    const translated = this.translate.instant('APARTMENT.METER_READINGS')
    this.modalService.open({
      component: MeterReadingsComponent,
      title: `${this.unitPipe.transform(data.unitType)} | ${translated}`,
      componentOptions: {
        selectedRow: data,
      },
      modalOptions: {
        size: "lg"

      }
    }).then(
      (res) => {
        if (res == ModalClose.SUCCESS) {
          this.loadData();
        }
      }
    );
  }
}
